import React from 'react';
import Button from 'react-bootstrap/Button';
import {SchemaProps} from "../../../types/Schema";
import {ConfirmationDialog} from "../../../common/Dialog";
import Notification from "../../../common/Notification";
import SomlService from "../../../services/soml-service";
import IconButton from "../../buttons/icon-button/IconButton";

type DeleteSchemaActionProps = {
  schema?: SchemaProps;
  schemaId?: string;
  onDelete: () => void;
  standardButton?: boolean;
  disabled?: boolean;
  forbidden?: boolean;
};

type DeleteSchemaActionState = {
  confirming: boolean
};

class DeleteSchemaAction extends React.Component<DeleteSchemaActionProps, DeleteSchemaActionState> {

  schemaId: string;

  constructor(props: DeleteSchemaActionProps) {
    super(props);
    this.state = {
      confirming: false
    };
    this.schemaId = this.props.schemaId || this.props.schema?.id || '';
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
    this.hideConfirmDialog = this.hideConfirmDialog.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  openConfirmDialog() {
    this.setState({
      confirming: true
    });
  }

  hideConfirmDialog() {
    this.setState({
      confirming: false
    });
  }

  confirmDelete() {
    SomlService.deleteSchema(this.schemaId)
      .then(() => {
        this.setState({
          confirming: false
        }, () => this.afterDelete());
      })
      .catch(err => this.cannotDelete(err));
  }

  afterDelete() {
    this.props.onDelete();
    Notification.success({message: 'Schema was deleted successfully.'});
  }

  cannotDelete(error: any) {
    const msg = error.message ? `Reason: ${error.message}` : '';
    Notification.error({message: `Schema was not deleted! ${msg}`});
  }

  render() {
    const title = this.props.forbidden ? "Delete schema is forbidden" : "Delete schema";
    const isDisabled = this.props.forbidden || this.props.disabled;
    return (
      <>
        {
          this.props.standardButton && <Button className="DeleteSchemaAction"
                                               onClick={this.openConfirmDialog}
                                               title={title}
                                               disabled={isDisabled}>
            Delete
          </Button>
        }
        {
          !this.props.standardButton &&
          <IconButton icon="trash-alt" onClick={this.openConfirmDialog}
                      title={title}
                      disabled={isDisabled}
                      className="DeleteSchemaAction"/>
        }
        <SchemaDeleteConfirmation id={this.schemaId}
                                  confirming={this.state.confirming}
                                  onConfirm={this.confirmDelete}
                                  onCancel={this.hideConfirmDialog}/>
      </>
    );
  }

}

export default DeleteSchemaAction;

function SchemaDeleteConfirmation(props: {
  id: string,
  confirming: boolean,
  onConfirm: () => void,
  onCancel: () => void
}) {
  if (!props.confirming) {
    return null;
  }
  const message = <span>Are you sure you want to delete schema <b>{props.id}</b></span>;
  return (
    <ConfirmationDialog
      className="SchemaDeleteConfirmation"
      message={message}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}/>
  );
}
